import { render, staticRenderFns } from "./LaporanInsentif.vue?vue&type=template&id=15871226"
import script from "./LaporanInsentif.vue?vue&type=script&lang=js"
export * from "./LaporanInsentif.vue?vue&type=script&lang=js"
import style0 from "./LaporanInsentif.vue?vue&type=style&index=0&id=15871226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports